<script>
import {  mapGetters } from 'vuex'
// eslint-disable-next-line
export default {
    computed: {
        ...mapGetters('emulator', ['hasSettingChange']),
        designer() {
            return window.__EMULATOR_DESIGNER__
        },
        currentDocument() {
            return this.designer?.project?.currentDocument || {}
        },
        hasDocumentChange() {
            return this.currentDocument?.hasChange
        },
        hasChange() {
            return this.hasDocumentChange || this.hasSettingChange
        },
    },
  
    methods: {
        openDesigner(item) {
            this.$router.push({ name: 'theme-design', params: item })
        },
    },
    render() {
        const events = {
            design: this.openDesigner,
        }
        return (
            <div>
                {
                    <ThemeList ref="theme" on={events}></ThemeList> //NOSONAR
                }
            </div>
        )
    },
}
</script>
